import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BRIEF_LIST_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useUpdateBriefOrganizationAllocation() {
  const {
    mutate: updateBriefOrganizationAllocation,
    isLoading: isUpdatingOrganizationAllocation,
    isSuccess: isUpdatedOrganizationAllocation,
    variables,
  } = useMutation({
    mutationFn: ({
      briefId,
      brandOrganisationManagers,
    }: {
      briefId: string;
      brandOrganisationManagers: string[];
    }) =>
      BriefService.updateBriefOrganisationAllocation(
        briefId,
        brandOrganisationManagers
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, data, { briefId }) => {
      ToastService.success("Campaign managers updated");

      const briefQueryKey = [...BRIEF_LIST_QUERY_KEY, briefId];
      c.setQueryData(briefQueryKey, data);
    },
  });
  return {
    updateBriefOrganizationAllocation,
    isUpdatingOrganizationAllocation,
    isUpdatedOrganizationAllocation,
    variables,
  };
}
